import { AxiosInstance } from "axios"

// const instances = new Map<string, AxiosInstance>()
let resolve: ((value: AxiosInstance) => void) | null = null
const p = new Promise<AxiosInstance>((r) => {
    resolve = r
})

export const setInstance = (instance: AxiosInstance) => {
  resolve!(instance)!
}

export const getInstance = () => {
    
  return p as Promise<AxiosInstance>
}